import { render, staticRenderFns } from "./ChatMessageInput.vue?vue&type=template&id=2e93a5ee&lang=pug&"
import script from "./ChatMessageInput.vue?vue&type=script&lang=js&"
export * from "./ChatMessageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatMessageInput.vue"
export default component.exports